import React from 'react';

function CalenderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <rect width="24" height="24" fill="#F3F2FD" rx="12"></rect>
      <path
        fill="#6754E2"
        d="M10.313 6.563V7.5h3.374v-.938c0-.304.235-.562.563-.562a.57.57 0 01.563.563V7.5h.937c.82 0 1.5.68 1.5 1.5v7.5c0 .844-.68 1.5-1.5 1.5h-7.5a1.48 1.48 0 01-1.5-1.5V9c0-.82.656-1.5 1.5-1.5h.938v-.938c0-.304.234-.562.562-.562a.57.57 0 01.563.563zM7.874 10.5v6c0 .21.164.375.375.375h7.5a.385.385 0 00.375-.375v-6h-8.25z"
      ></path>
    </svg>
  );
}
export default CalenderIcon;
